import { useEffect } from "react";

import { clsxMerge } from "shared/lib/helpers";
import SidebarV2 from "shared/ui/sidebarV2";
import { SidebarSlide } from "shared/ui/sidebarV2/components/slide";
import { SIDEBAR_SIZE } from "shared/ui/sidebarV2/lib/constants";
import { GitbookMarkdownPreview } from "shared/ui/markdown/gitbook-preview";
import { TIME_INTERVALS } from "shared/lib/constants/time";
import { Skeleton } from "shared/ui/shadcn/skeleton";

import { useDocsStore, closeDocsSidebar } from "@/lib/store/docs";
import { useQueryFetchGitbookDocs } from "@/api/routes/docs/queries";
import { DocsEmptyState } from "@/components/shared/docs/shared/empty-state";

const PendingState = () => (
  <div className="flex flex-col space-y-4">
    <Skeleton className="h-[120px] w-full bg-[#e6e6e7]" />
    <Skeleton className="h-[225px] w-full bg-[#e6e6e7]" />
    <div className="space-y-2">
      <Skeleton className="h-6 w-full bg-[#e6e6e7]" />
      <Skeleton className="h-6 w-full bg-[#e6e6e7]" />
      <Skeleton className="h-6 w-[200px] bg-[#e6e6e7]" />
    </div>
  </div>
);

export const DocsSidebar = () => {
  const isOpen = useDocsStore((state) => state.isOpen);
  const spaceId = useDocsStore((state) => state.spaceId);
  const path = useDocsStore((state) => state.path);

  const { data, isLoading, refetch, dataUpdatedAt } = useQueryFetchGitbookDocs(
    spaceId,
    path
  );

  const isDataStale =
    !dataUpdatedAt || Date.now() - dataUpdatedAt > TIME_INTERVALS.FIVE_MINUTES;

  useEffect(() => {
    if (spaceId && path && isOpen && isDataStale) {
      refetch();
    }
  }, [spaceId, path, isOpen, isDataStale]);

  return (
    <SidebarV2 isOpen={isOpen} onClose={() => closeDocsSidebar()}>
      <SidebarSlide title={data?.title} size={SIDEBAR_SIZE.MD}>
        {!isLoading && !data?.markdown && <DocsEmptyState />}

        {isLoading ? (
          <PendingState />
        ) : (
          <div>
            <div className="mb-6 typography-body-4">{data?.description}</div>

            <GitbookMarkdownPreview
              className={clsxMerge(
                "typography gitbook-markdown break-words",
                // the first child is the title, which we already show in the sidebar header
                "[&>*:first-child]:hidden"
              )}
              path={path}
            >
              {data?.markdown}
            </GitbookMarkdownPreview>
          </div>
        )}
      </SidebarSlide>
    </SidebarV2>
  );
};
